import { useEffect } from "react";

import { getClassName } from "./CustomInput.utils";

interface Props {
  id: string;
  setValue: (id: string, value: any) => void;
  ambHeightCalc: string | undefined;
}
/**
 * Custom hook to calculate and update the ambassador height difference based on input changes.
 *
 * @param props - An object containing the following properties:
 *   - id: A string representing the unique identifier for the input.
 *   - setValue: A function to update the calculated value.
 *   - ambHeightCalc: An optional string indicating the calculation type and range.
 */
const useAmbHeightCalc = ({ ambHeightCalc, id, setValue }: Props) => {
  useEffect(() => {
    if (ambHeightCalc && ambHeightCalc.includes("range")) {
      const number = ambHeightCalc.replace("range", "");

      const handlehwOrlwChange = (e: any, key: "lw" | "hw") => {
        const firstValue = e.target.value;

        const otherKey = key === "lw" ? "hw" : "lw";
        const otherElementValue = Number(
          document
            .querySelector(
              `.${getClassName("ambHeightCalc", `${otherKey}${number}`)}`,
            )
            ?.querySelector("input")?.value ?? 0,
        );

        setValue(id, Math.abs(firstValue - otherElementValue));
      };

      const hwClassName = getClassName("ambHeightCalc", `hw${number}`);
      const lwClassName = getClassName("ambHeightCalc", `lw${number}`);
      document
        .querySelector(`.${hwClassName}`)
        ?.querySelector("input")
        ?.addEventListener("change", e => handlehwOrlwChange(e, "hw"));
      document
        .querySelector(`.${lwClassName}`)
        ?.querySelector("input")
        ?.addEventListener("change", e => handlehwOrlwChange(e, "lw"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [ambHeightCalc, id]);
};
export default useAmbHeightCalc;
